import React, { useState, useRef, useEffect } from 'react';
import { User } from '../../hooks/useAuth';
import './AuthButton.css';

interface AuthButtonProps {
    user?: User | null;
    onOpenAuthModal: () => void;
    onLogout: () => void;
}

const AuthButton: React.FC<AuthButtonProps> = ({ user, onOpenAuthModal, onLogout }) => {
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef<HTMLDivElement>(null);

    // Fermer le menu quand on clique en dehors
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleActionClick = (action: () => void) => {
        action();
        setIsOpen(false);
    };

    return (
        <div className="auth-button" ref={buttonRef}>
            <button
                className="auth-button-main"
                onClick={() => user ? setIsOpen(!isOpen) : onOpenAuthModal()}
                title={user ? `Connecté en tant que ${user.username}` : 'Se connecter'}
            >
                <span className="auth-icon">
                    {user ? '👤' : '🔐'}
                </span>
            </button>

            {isOpen && user && (
                <div className="auth-menu">
                    <div className="auth-menu-content">
                        <div className="user-info">
                            <span className="user-avatar">👤</span>
                            <div className="user-details">
                                <div className="username">{user.username}</div>
                                <div className="email">{user.email}</div>
                            </div>
                        </div>
                        <div className="auth-separator"></div>
                        <button
                            className="auth-menu-item logout"
                            onClick={() => handleActionClick(onLogout)}
                        >
                            <span className="auth-menu-icon">🚪</span>
                            <span>Se déconnecter</span>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AuthButton;
